import { render, staticRenderFns } from "./ReportePropinas.vue?vue&type=template&id=1c9e20d4&scoped=true"
import script from "./ReportePropinas.vue?vue&type=script&lang=js"
export * from "./ReportePropinas.vue?vue&type=script&lang=js"
import style0 from "./ReportePropinas.vue?vue&type=style&index=0&id=1c9e20d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9e20d4",
  null
  
)

export default component.exports